export default __webpack_public_path__ + "static/Michel_Jongen_2-3fb5070728fe7d088b30bd89ea0707f2.jpg";